import styled from 'styled-components'
import { FONT_WEIGHT, SPACE } from 'Theme'

export const LI = styled('li')`
  margin: ${SPACE.PX_16} 0;
  font-weight: ${FONT_WEIGHT.NORMAL};
  text-align: justify;
`
